import { FormattedMessage } from "react-intl";

import styled from "@emotion/styled";

import FormLabel from "@mui/material/FormLabel";

// Chaque lien n'est affiché que si l'école l'a renseigné.
function PersonalDataConditions({ rgpdUrl, copyrightUrl }) {
  if (!rgpdUrl && !copyrightUrl) {
    return null;
  }
  return (
    <StyledDiv>
      <StyledLabel>
        {rgpdUrl && (
          <a href={rgpdUrl} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="rgpd" />
          </a>
        )}
        {rgpdUrl && copyrightUrl && "&"}
        {copyrightUrl && (
          <a href={copyrightUrl} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="copyright" />
          </a>
        )}
      </StyledLabel>
    </StyledDiv>
  );
}

const StyledDiv = styled.div`
  text-align: center;
  margin: 24px 0;
`;

const StyledLabel = styled(FormLabel)`
  color: #575757;
`;

export default PersonalDataConditions;
